import movieActionTypes from "./movies.type";
import { searchMovie, searchOrder, deleteMovie } from "./movies.utils";

const INITIAL_STATE = {
  allMovies: [],
  vertualMovies: [],
  orders: [],
  vertualOrders: [],
  longevity: {},
  isLoading: false,
};

const moviesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case movieActionTypes.FETCH_MOVIES_START:
    case movieActionTypes.ADD_TO_ORDER_START:
    case movieActionTypes.ADD_MOVIE_START:
    case movieActionTypes.ADD_MOVIE_LONGEVITY_START:
    case movieActionTypes.FETCH_ORDERS_START:
    case movieActionTypes.DELETE_MOVIE_START:
      return {
        ...state,
        isLoading: true,
      };
    case movieActionTypes.FETCH_MOVIES_SUCCESS:
      return {
        ...state,
        allMovies: action.payload,
        vertualMovies: action.payload,
        isLoading: false,
      };
    case movieActionTypes.FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        vertualOrders: action.payload,
        isLoading: false,
      };
    case movieActionTypes.SEARCH_MOVIE:
      return {
        ...state,
        vertualMovies: searchMovie(state.allMovies, action.payload),
      };
    case movieActionTypes.SEARCH_ORDER:
      return {
        ...state,
        vertualOrders: searchOrder(state.orders, action.payload),
      };
    case movieActionTypes.DELETE_MOVIE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        vertualMovies: deleteMovie(state.vertualMovies, action.payload),
      };
    case movieActionTypes.FETCH_MOVIES_FAILURE:
    case movieActionTypes.ADD_TO_ORDER_SUCCESS:
    case movieActionTypes.ADD_MOVIE_LONGEVITY_SUCCESS:
    case movieActionTypes.ADD_MOVIE_LONGEVITY_FAILURE:
    case movieActionTypes.ADD_TO_ORDER_FAILURE:
    case movieActionTypes.FETCH_ORDERS_FAILURE:
    case movieActionTypes.ADD_MOVIE_SUCCESS:
    case movieActionTypes.ADD_MOVIE_FAILURE:
    case movieActionTypes.DELETE_MOVIE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default moviesReducer;
